import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import numFormat from './num-format';

const sliderElement = document.querySelector('.rate-slider');
const ratesElement = document.querySelector('.pricing__rates');
const MIN_COST = 100000;
const MAX_COST = 20000000;
const DEFAULT_COST = 100000;
const STEP = 100000;

const DISC_1_PERCENT = 0.2;
const DISC_2_PERCENT = 0.35;

const sliderOpts = {
  start: DEFAULT_COST,
  step: STEP,
  connect: [true, false],
  range: {
    'min': [MIN_COST],
    'max': [MAX_COST]
  },
  tooltips: wNumb({
    decimals: 0,
    thousand: ',',
    prefix: '$'
  })
};

class Calculator {
  constructor(sliderRoot, ratesRoot, disc_1_percent, disc_2_percent) {
    this._sliderElement = sliderRoot;
    this._ratesElement = ratesRoot;
    this._sliderOpts = {
      start: DEFAULT_COST,
      step: STEP,
      connect: [true, false],
      range: {
        'min': [MIN_COST],
        'max': [MAX_COST]
      },
      tooltips: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$'
      })
    };
    this._slider = null;

    this._calculatedStrings = [...this._ratesElement.querySelectorAll('[data-calc]')];

    this.disc_1_percent = disc_1_percent;
    this.disc_2_percent = disc_2_percent;
  }

  init() {
    noUiSlider.create(this._sliderElement, this._sliderOpts);
    this._slider = this._sliderElement.noUiSlider;
    const defaultWidth = this._sliderElement.offsetWidth;
    const connect = this._sliderElement.querySelector('.noUi-connect');
    this.updateValues();

    this._slider.on('update', () => {
      const progress = parseInt(this._slider.get()) / MAX_COST;
      connect.style.transform = 'none';
      connect.style.width = `${defaultWidth * progress}px`;

      this.updateValues();

      console.log(`
        deal_amount: ${this.deal_amount}
        success_fee_amount: ${this.success_fee_amount}
        success_fee_percent: ${this.success_fee_percent}
        disc_1_amount: ${this.disc_1_amount}
        disc_fee_1_total_amount: ${this.disc_fee_1_total_amount}
        disc_fee_1_half_amount: ${this.disc_fee_1_half_amount}
        disc_2_amount: ${this.disc_2_amount}
        disc_fee_2_amount: ${this.disc_fee_2_amount}
      `)
    });
  }

  updateValues() {
    this._calculatedStrings.forEach((item) => {
      const label = item.dataset.calc;
      if (this[label]) {
        item.textContent = numFormat(this[label]);
      }
    });
  }

  get deal_amount() {
    return parseInt(this._slider.get());
  }

  get success_fee_amount() {
    const structure = [
      0.005,
      0.004,
      0.003,
      0.002,
      0.001,
      0.0005,
    ];
    const step = 1000000;

    let amount = this.deal_amount;
    let fee = 0;

    structure.forEach((level, i) => {
      const isLast = i === structure.length - 1;

      if (amount > step && !isLast) {
        amount = amount - step;
        fee += step * level;
      } else if (amount > 0) {
        fee += amount * level;
        amount = 0;
      }

    });

    return Math.round(fee);
  }

  get success_fee_percent () {
    const percent = this.success_fee_amount / this.deal_amount * 100;
    return (Math.round(percent * 100) / 100);
  }

  get disc_1_amount () {
    return Math.round(this.success_fee_amount * this.disc_1_percent);
  }

  get disc_fee_1_total_amount() {
    return Math.round(this.success_fee_amount - this.disc_1_amount);
  }

  get disc_fee_1_half_amount () {
    return this.disc_fee_1_total_amount / 2;
  }

  get disc_2_amount() {
    return Math.round(this.success_fee_amount * this.disc_2_percent);
  }

  get disc_fee_2_amount() {
    return Math.round(this.success_fee_amount - this.disc_2_amount);
  }

}

const calc = new Calculator(sliderElement, ratesElement, DISC_1_PERCENT, DISC_2_PERCENT);

export default calc;
